import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { fetchReferralPage, fetchReferral, requestPaymentOAuth, requestPaymentNoAuth, requestPaymentPaypal } from 'app/api/support-api';
import { getSectionForPageByIdAndType, getStringsForPage } from 'app/common/selectors/page';
import { contentfulUtils } from '@glowforge/ui-common';
import ReferralPaymentPage from 'app/components/support/referral/payment-page';

const { stringSubstitution } = contentfulUtils;

// Recursively iterates through a contentful object and its children to replace occurences of
// {{cash-amount}} and {{credit-amount}} with the appropriate values
const replaceExchangeValues = (replaceable, cashAmount, creditAmount) => {
  if (typeof replaceable === 'string') {
    return stringSubstitution(
      replaceable,
      [
        {
          name: 'cash-amount',
          value: cashAmount,
        },
        {
          name: 'credit-amount',
          value: creditAmount,
        },
      ],
    );
  }
  _.forEach(replaceable, (value, key) => {
    if (key === 'sys') return;
    const replacedObject = {};
    replacedObject[key] = replaceExchangeValues(value, cashAmount, creditAmount);
    _.assign(replaceable, replacedObject);
  });

  return replaceable;
};

const mapStateToProps = (state, ownProps) => {
  const cashAmount = _.get(state, 'support.referralInfo.cashAmount');
  const creditAmount = _.get(state, 'support.referralInfo.creditAmount');
  const page = replaceExchangeValues(_.get(state, 'support.referralPage'), cashAmount, creditAmount);

  return ({
    ..._.get(state, 'support.referralInfo'),
    status: _.get(state, 'support.status'),
    path: _.get(ownProps, 'location.query.state'),
    paypal: _.get(ownProps, 'location.query.paypal'),
    pageStrings: getStringsForPage(page),
    mainPageContent: getSectionForPageByIdAndType(page, 'stripe-exchange-content', 'textSection'),
    paypalLinkText: getSectionForPageByIdAndType(page, 'paypal-request-page-link-text', 'textSection'),
    paypalPageContent: getSectionForPageByIdAndType(page, 'paypal-page', 'textSection'),
    createPaypalText: getSectionForPageByIdAndType(page, 'create-paypal-text', 'textString'),
    returningText: getSectionForPageByIdAndType(page, 'returner-reconnect-text', 'textSection'),
    confirmationPageContent: getSectionForPageByIdAndType(page, 'stripe-exchange-confirmation', 'textSection'),
    paypalConfirmationPageContent: getSectionForPageByIdAndType(page, 'paypal-confirmation-page-rto', 'textSection'),
    errorStrings: _.get(getSectionForPageByIdAndType(page, 'error-strings-rto', 'list'), 'listItems'),
  });
};

const mapDispatchToProps = dispatch => ({
  requestPayment: (stripeID, referralState) => dispatch(
    requestPaymentNoAuth(stripeID, referralState),
  ),
  requestPaypal: (paypalEmail, referralState) => dispatch(
    requestPaymentPaypal(paypalEmail, referralState),
  ),
});

const ReferralPaymentContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, location }) => Promise.all([
    dispatch(fetchReferralPage()),
    dispatch(fetchReferral(location.query.state)),
    dispatch(requestPaymentOAuth(location.query.code, location.query.state)),
  ]),
)(ReferralPaymentPage),
);

export default ReferralPaymentContainer;



// WEBPACK FOOTER //
// ./app/containers/support/referral-payment.js